import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientProductsRoute } from '../route';

export const clientPackagesRoute = createRoute({
	path: '/packages',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientPackagesPage'),
		'ClientPackagesPage',
	),
});
